import Dexie, { type Table } from 'dexie'
import type { DocumentRecord, ScreenshotRecord, SettingKey, SettingRecord } from './types'

class MarkViewDatabase extends Dexie {
  documents!: Table<DocumentRecord, string>
  screenshots!: Table<ScreenshotRecord, string>
  settings!: Table<SettingRecord, SettingKey>

  constructor() {
    super('markview')

    this.version(2).stores({
      documents: '&id, importSignature, updatedAt',
      screenshots: '&id, documentId, createdAt',
      settings: '&key, updatedAt',
    })
  }
}

export const db = new MarkViewDatabase()

export async function getSetting<T>(key: SettingKey, fallback: T): Promise<T> {
  const setting = await db.settings.get(key)
  return (setting?.value as T | undefined) ?? fallback
}

export async function setSetting<T>(key: SettingKey, value: T) {
  await db.settings.put({
    key,
    value,
    updatedAt: Date.now(),
  })
}
